(() => {
  angular
    .module('gm.common.filters')
    .filter('gmCountryWithProvince', gmCountryWithProvinceFilter);

  function gmCountryWithProvinceFilter() {
    'ngInject';

    return countryCode => ['CA', 'FA'].indexOf(countryCode) > -1;
  }
})();
